import React from 'react';
import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@mui/material';

type DialogProps = MuiDialogProps & {
  children?: any;
};

export const Dialog = ({ children = null, ...rest }: DialogProps) => {
  return (
    <MuiDialog maxWidth="sm" scroll="body" {...rest}>
      {children}
    </MuiDialog>
  );
};
